import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBottomSheet",
    {
      attrs: {
        eager: "",
        persistent: _vm.persistent,
        "no-click-animation": _vm.persistent,
        "is-visible": _vm.isVisibleWithDelay,
        width: _vm.isMobile ? "100%" : "360px",
      },
      on: {
        "dialog-bottom-sheet:change-visible": function ($event) {
          return _vm.$emit("modal:update-visible", $event)
        },
      },
    },
    [
      _c(
        VCard,
        [
          _c(VCardTitle, { staticClass: "pb-4" }, [
            _c("div", { staticClass: "text-h6 text--text" }, [
              _vm._v("\n        Войдите, чтобы продолжить\n      "),
            ]),
          ]),
          _vm._v(" "),
          !_vm.isMobile ? _c(VDivider) : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.isMobile ? "px-2" : "px-4 pt-6" },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "px-4 pt-2 pb-6" }, [
            _c(
              "div",
              { staticClass: "text-body-2 text-secondary--text text-center" },
              [
                _vm._v(
                  "\n        Подтверждая номер, вы даете согласие на\n        "
                ),
                _c(
                  "a",
                  {
                    staticClass: "text-decoration-none primary--text",
                    attrs: { href: "/info/privacy-policy/", target: "_blank" },
                  },
                  [_vm._v("обработку персональных данных")]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v("\n        и принимаете\n        "),
                _c(
                  "a",
                  {
                    staticClass: "text-decoration-none primary--text",
                    attrs: { href: "/info/terms-of-use/", target: "_blank" },
                  },
                  [_vm._v("пользовательское соглашение")]
                ),
                _vm.usePublishingPolicy
                  ? [
                      _vm._v(", а также согласны с\n          "),
                      _c(
                        "a",
                        {
                          staticClass: "text-decoration-none primary--text",
                          attrs: {
                            href: "/info/publishing-policy/",
                            target: "_blank",
                          },
                        },
                        [_vm._v("политикой публикации материалов")]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }